<template>
  <div class="sample-validation-view">
    <SampleValidationTabs />
  </div>
</template>

<script>
import SampleValidationTabs from "../components/layout/SampleValidation/SampleValidationTabs.vue";

export default {
  name: "SampleInformation",
  components: {
    SampleValidationTabs,
  },
};
</script>
